import { camelCase } from './util.js'
export var training = [
  {
    thumb: camelCase('training-pic1'),
    img: camelCase('training-pic1'),
    title: '第一节 品牌有套路',
    desc: '惠建军 总经理主持开课 , 史贵洪 资深策略总监授课',
    content: ''
  },
  {
    thumb: camelCase('training-pic2'),
    img: camelCase('training-pic2'),
    title: '第二节 点子有亮度',
    desc: '周晶 创意群总监',
    content: ''
  },
  {
    thumb: camelCase('training-pic3'),
    img: camelCase('training-pic2'),
    title: '第三节 网络有绝招',
    desc: '顾丽媛 资深网络策略总监',
    content: ''
  },
  {
    thumb: camelCase('training-pic4'),
    img: camelCase('training-pic4'),
    title: '第四节 创意有奇巧',
    desc: '陈智德 创意群总监',
    content: ''
  },
  {
    thumb: camelCase('training-pic5'),
    img: camelCase('training-pic5'),
    title: '第五节 公关有作为',
    desc: '关俊之 资深公关总监',
    content: ''
  },
  {
    thumb: camelCase('training-pic6'),
    img: camelCase('training-pic6'),
    title: '第六节 媒介有势力',
    desc: '寇旭玲 资深媒介总监',
    content: ''
  },
  {
    thumb: camelCase('training-pic7'),
    img: camelCase('training-pic7'),
    title: '第七节 客服有热情',
    desc: '杜鹃 副总经理兼客户部总经理',
    content: ''
  },
  {
    thumb: camelCase('training-pic8'),
    img: camelCase('training-pic8'),
    title: '第八节 户外有实行',
    desc: '许爱萍 活动总监',
    content: ''
  },
  {
    thumb: camelCase('training-pic9'),
    img: camelCase('training-pic9'),
    title: '第九节 案例复盘',
    desc: '史贵洪 资深策略总监授课',
    content: ''
  },
  {
    thumb: camelCase('training-pic10'),
    img: camelCase('training-pic10'),
    title: '第十节 事业有前途',
    desc: '',
    content: ''
  }

]
export var outer = []

for (var i = 1; i <= 8; i++) {
  outer.push({
    thumb: camelCase(`training-travel${i}`)
  })
}
